import React from 'react';
import { FunnelIcon } from '@heroicons/react/24/outline';

const SortToolbar = ({ totalCount, sortBy, onSortChange, hasActiveFilters, onClearFilters, t }) => {
  if (totalCount === 0) return null;
  return (
    <div className="flex items-center justify-between mb-4 gap-3 flex-wrap">
      <p className="text-sm text-gray-500 font-medium">
        {t('events.showing', { count: totalCount })}
      </p>
      <div className="flex items-center gap-2">
        {hasActiveFilters && (
          <button onClick={onClearFilters} className="flex items-center gap-1 text-xs font-bold text-red-500 hover:text-red-600 active:scale-95 transition-colors min-h-[44px] px-3 rounded-lg border border-red-200 bg-red-50">
            <FunnelIcon className="h-3.5 w-3.5" />
            {t('events.clearFilters')}
          </button>
        )}
        <select
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
          className="text-xs font-bold text-gray-600 bg-white border border-gray-200 rounded-xl px-3 py-2 min-h-[44px] outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer"
        >
          <option value="dateAsc">{t('events.sort.dateAsc')}</option>
          <option value="newest">{t('events.sort.newest')}</option>
          <option value="providerAsc">{t('events.sort.providerAsc')}</option>
        </select>
      </div>
    </div>
  );
};

export default SortToolbar;
